import { Modal, Button, MediaUpload } from '@components/ui';
import { formatCurrency, formatDate, getDurumBadge } from './StockIndicator';
import { FileText, ExternalLink } from 'lucide-react';

/**
 * MaterialDetailModal - Malzeme detay görüntüleme modalı
 * 
 * @param {boolean} isOpen - Modal açık mı
 * @param {function} onClose - Kapatma
 * @param {object} data - Kayıt verisi
 * @param {Array} fields - Gösterilecek alanlar [{key, label, type}]
 * @param {string} title - Modal başlığı
 */
export default function MaterialDetailModal({
    isOpen,
    onClose,
    data,
    fields = [],
    title = 'Kayıt Detayı',
}) {
    if (!data) return null;

    // Değer formatlama
    const formatValue = (value, type) => {
        if (value === null || value === undefined) return '-';

        switch (type) {
            case 'date':
                return formatDate(value);
            case 'currency':
                return formatCurrency(value);
            case 'status':
                return getDurumBadge(value);
            case 'boolean':
                return value ? 'Evet' : 'Hayır';
            case 'number':
                return value.toLocaleString('tr-TR');
            default:
                return value;
        }
    };

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title={title}
            size="md"
            footer={
                <Button variant="ghost" onClick={onClose}>
                    Kapat
                </Button>
            }
        >
            <div className="space-y-4">
                {/* Bilgi Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {fields.map((field) => (
                        <div
                            key={field.key}
                            className={`${field.fullWidth ? 'md:col-span-2' : ''}`}
                        >
                            <p className="text-xs text-text-muted mb-1">{field.label}</p>
                            <div className="text-sm text-text-primary font-medium">
                                {formatValue(data[field.key], field.type)}
                            </div>
                        </div>
                    ))}
                </div>

                {/* Not Alanı */}
                {data.not && (
                    <div className="p-3 bg-bg-tertiary rounded-lg">
                        <p className="text-xs text-text-muted mb-1">Not</p>
                        <p className="text-sm text-text-primary">{data.not}</p>
                    </div>
                )}

                {/* Belge / İrsaliye */}
                <div className="border-t border-border-light pt-4">
                    <p className="text-xs font-semibold text-text-muted uppercase tracking-wide mb-3">Belge / İrsaliye</p>
                    {data.document_url ? (
                        <a
                            href={data.document_url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex items-center gap-2 p-3 rounded-lg border border-border-light bg-bg-secondary hover:bg-bg-hover transition-colors text-sm text-primary"
                        >
                            <FileText size={16} />
                            <span className="flex-1 truncate">Eki Görüntüle</span>
                            <ExternalLink size={14} className="shrink-0 text-text-muted" />
                        </a>
                    ) : (
                        <MediaUpload
                            mode="single"
                            accept="all"
                            label=""
                            hint="İrsaliye veya teslimat belgesi ekleyin"
                            maxSizeMB={10}
                            compact
                            onFilesChange={() => {}}
                        />
                    )}
                </div>
            </div>
        </Modal>
    );
}
